import React from 'react';

import SelectionDialog from "views/widgets/SelectionDialog.jsx";

export default function AttributeSelectionDialog(props) {

	let { additionalUrlParams, closeCallback, okCallback, initialHeight = 700, initialWidth = 850 } = props;
	
	const enumMapping = {
		'STRING': 'String',
		'NUMBER': 'Number',
		'DATE': 'Date',
		'TIMESTAMP': 'Timestamp',
		'BOOLEAN': 'Boolean',
		'PICKLIST': 'Pick List',
		'MULTIVALUE': 'Multi Value', 
		'SELECTOR': 'Selector'
	};
	const formatEnum = enumVal => enumMapping[enumVal];
	
	const columns = [
				{ field: "name", title: "Name", sort: "attributeName", width: 200 },
				{ field: "identifier", title: "Identifier", sort: "attributeIdentifier", width: 200 },
				{ field: "description", title: "Description", sort: "attributeDescription", width: 200 },
				{ field: "type", title: "Title", sort: "attributeType", width: 200, transform: formatEnum },
				{ field: "workspace.name", title: "Workspace", sort: "workspace.workspaceName" }
	];
	
	const sort = [
		{ field: "attributeName", dir: "asc" }
	];

	return (
		<SelectionDialog
			label="Attributes"
			type="attributes"
			url="/api/attributes/"
			additionalUrlParams={additionalUrlParams}
			columns={columns}
			sort={sort}
			initialHeight={initialHeight}
			initialWidth={initialWidth}
			cancelCallback={closeCallback}
			okCallback={okCallback}
			toolTip="Search Attribute Name and Description"
		/>
	);
}